import { create } from "zustand";
import { GlobalDialogType, StoreStateType } from "./types";
import { DownloadStickerRequest } from "./types/requests";
import { DOWNLOAD_QR_CODE_STICKER } from "service/paths";
import instance from "service";
import { DownloadStickerResponse } from "./types/responses";

const useStore = create<StoreStateType>((set, get) => ({
    globalDialog: {
        isOpen: false,
        title: '',
        description: ''
    },

    setGlobalDialog: (globalDialog: GlobalDialogType) => {
        set((state: StoreStateType) => ({ ...state, globalDialog }));
    },

    hideGlobalDialog: async () => {
        set((state: StoreStateType) => ({
            ...state,
            globalDialog: {
                isOpen: false,
                title: "",
                description: "",
                actionTitle: "",
                action: () => { },
            }
        }))
    },

    isFetching: false,

    setIsFetching: (value: boolean) => {
        set((state: StoreStateType) => ({ ...state, isFetching: value }));
    },
    
    qrCodeDownload: {
         downloadQrCodeSticker: async (request: DownloadStickerRequest, callback: (response: DownloadStickerResponse) => void) => {
            get().setIsFetching(true);
            await instance.post(DOWNLOAD_QR_CODE_STICKER, request)
                .then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    if(Exp.response.data.returnCode === "CLIENT_NOT_FOUND"){
                        set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, une erreur s'est produite!", description: "Le numéro est introuvable! Veuillez réessayer." }
                    }));
                    } else {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, une erreur s'est produite!", description: "Une erreur s'est produite lors du traitement ! Veuillez réessayer." }
                    }));}
                });
            get().setIsFetching(false);
        },

    }
}));

export const {
    getState: getStore,
    setState: setStore
} = useStore;

export default useStore;